import { render } from "./time-switcher.vue?vue&type=template&id=370ca858&scoped=true&ts=true"
import script from "./time-switcher.vue?vue&type=script&lang=ts"
export * from "./time-switcher.vue?vue&type=script&lang=ts"

import "./time-switcher.vue?vue&type=style&index=0&id=370ca858&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370ca858"]])

export default __exports__